import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { Modal, ButtonModalClose } from 'platfi-ui-components';
import EmailClientTab from './components/EmailClientTab/EmailClientTab';
import CopyLinkTab from './components/CopyLinkTab/CopyLinkTab';

export default class InviteClientModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    inviteLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    sendEmailInvite: PropTypes.func.isRequired,
    requestInviteLink: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.requestInviteLink();
  }

  render() {
    const { email, isOpen, inviteLink, sendEmailInvite, closeModal } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        contentLabel="Invite Client Modal"
        closeButton={
          <ButtonModalClose className="o-modal__fade o-modal__close" handleClose={closeModal} />
        }
      >
        <div className="o-modal-funding-report">
          <div className="u-align-center">
            <h1 className="o-modal__title">Invite your client to complete a funding report</h1>
            <p className="o-modal__text">
              Your client will be sent to a Accountant Franchise branded page to complete the
              funding report survey.
              <br />
              Once they complete the survey you will receive a notification via email with a link to
              view the report.
            </p>
          </div>
          <div className="o-modal-funding-report__tabs">
            <div className="o-container-xxxs">
              <Tabs className="m-tabs-alt" selectedTabClassName="m-tabs-alt__tab--selected">
                <TabList className="m-tabs-alt__tabs-list">
                  <Tab className="m-tabs-alt__tab">Email Client</Tab>
                  <Tab className="m-tabs-alt__tab">Copy Link</Tab>
                </TabList>
                <TabPanel className="m-tabs-alt__tab-panel">
                  <EmailClientTab
                    email={email}
                    sendEmailInvite={sendEmailInvite}
                    closeModal={closeModal}
                  />
                </TabPanel>
                <TabPanel className="m-tabs-alt__tab-panel">
                  <CopyLinkTab inviteLink={inviteLink} />
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
